import {useQuery} from '@apollo/client';
import {useSelector} from 'react-redux';
import {toast} from 'react-toastify';
import {GET_ALL_ACTIVE_ANNOUNCEMENT} from 'graphql/queries/announcement';
import {makeSelectTabOperations} from 'redux/store/auth';
import {NavTabsEnum} from 'utils/constants';
import {AnnouncementsList} from '../components/AnnouncementsList';

const ActiveAnnouncements = () => {
  const operations = useSelector(state =>
    makeSelectTabOperations(state, NavTabsEnum.Announcements),
  );

  const {data, loading, refetch} = useQuery(GET_ALL_ACTIVE_ANNOUNCEMENT, {
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'all',
    onError: error => toast.error(error.message),
  });

  return (
    <AnnouncementsList
      status="active"
      loading={loading}
      refetch={refetch}
      operations={operations}
      announcements={data?.getAllActiveAnnouncements?.announcement || []}
    />
  );
};

export {ActiveAnnouncements};
